<template>
  <div>
    <v-tooltip left>
      <template
        v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          fab
          x-small
          depressed
          color="primary"
          @click="isOpen = true">
          <v-icon
            icon
            small>
            mdi-pencil-outline
          </v-icon>
        </v-btn>
      </template>
      <span>{{ $t('combos.modals.edit.title') }}</span>
    </v-tooltip>
    <v-dialog @keydown.esc="isOpen=false" v-model="isOpen" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Editar {{ combo.name }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="editComboForm" v-model="form.valid">
            <v-container grid-list-xl>
              <v-layout wrap>
                <v-flex xs12 md12>
                  <v-text-field
                    :label="$t('combos.labels.internalId')"
                    :rules="combo.validation().internalId"
                    v-model="form.data.internalId"
                  >
                  </v-text-field>
                  <v-text-field
                    :label="$t('combos.labels.name')"
                    :rules="combo.validation().name"
                    v-model="form.data.name"
                    required>
                  </v-text-field>
                  <v-text-field
                    :label="$t('combos.labels.price')"
                    :rules="combo.validation().price"
                    v-model="form.data.price">
                  </v-text-field>
                  <v-flex
                    xs12 md12 class="d-flex"
                  >
                    <NewSection />
                    <v-select
                      data-cy="section"
                      :label="$t('combos.labels.section')"
                      v-model="form.data.section"
                      :items="sections"
                      item-text="name"
                      item-value="id"
                      return-object
                    />
                  </v-flex>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="mr-4"
            outlined
            rounded
            small
            depressed
            @click="closeDialog">
            {{ $t('combos.actions.close') }}
          </v-btn>
          <v-btn
            color="success"
            class="mr-4"
            rounded
            small
            depressed
            @click="submit">
            {{ $t('combos.actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import Combo from '@/models/Combo'
import NewSection from '@/components/modals/NewSection'

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: {
    NewSection
  },
  data () {
    let combo = new Combo(this.item.$)

    return {
      overlay: false,
      isOpen: false,
      combo,
      form: {
        valid: false,
        data: {}
      }
    }
  },
  watch: {
    isOpen (val) {
      if (val) {
        this.setInitialCombo()
      }
    }
  },
  computed: {
    sections: function () {
      return this.$store.state.currentRestaurant.sections.data || []
    }
  },
  methods: {
    submit: async function () {
      this.$refs.editComboForm.validate()

      if (this.form.valid) {
        this.overlay = true
        this.combo.set(this.form.data)
        try {
          await this.combo.save()
          this.$emit('updated', this.combo)
          this.closeDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    setInitialCombo () {
      this.resetComboForm()
      this.form.data = cloneDeep(this.item.$)
    },
    resetComboForm () {
      if (this.$refs.editComboForm) this.$refs.editComboForm.reset()
      this.form.data = {}
    },
    closeDialog () {
      this.isOpen = false
      this.resetComboForm()
      this.$emit('close', false)
    }
  }
}
</script>
